import React from 'react';
import {
  AlertDialog,
  AlertDialogCloseButton,
  AlertDialogOverlay,
  useBreakpointValue,
  UseDisclosureReturn,
} from '@chakra-ui/react';
import {
  StyledAlertDialogContent,
  StyledAlertDialogHeader,
  StyledAlertDialogFooter,
  StyledButton,
} from './styles';

interface CancellationExceedDialogProps {
  isOpen: UseDisclosureReturn['isOpen'];
  onClose: UseDisclosureReturn['onClose'];
}

export const CancellationExceedDialog: React.FC<CancellationExceedDialogProps> =
  ({ isOpen, onClose }) => {
    const cancelRef = React.useRef(null);
    const buttonVariant = useBreakpointValue(
      {
        base: 'ghost',
        xs: 'ghost',
        md: 'outline',
      },
      'outline',
    );

    return (
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        isCentered
      >
        <AlertDialogOverlay backdropFilter={{ base: 'none', md: 'blur(2px)' }}>
          <StyledAlertDialogContent>
            {buttonVariant === 'outline' && <AlertDialogCloseButton />}
            <StyledAlertDialogHeader>
              Истекло доступное для отмены время
            </StyledAlertDialogHeader>

            <StyledAlertDialogFooter>
              <StyledButton
                ref={cancelRef}
                onClick={onClose}
                variant={buttonVariant}
                borderRadius={{ base: '0 0 8px 8px', md: '16px' }}
                size="sm"
              >
                Закрыть
              </StyledButton>
            </StyledAlertDialogFooter>
          </StyledAlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    );
  };
